import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { queryKeys } from '@utils/consts';
import { useAppContext } from '@contexts/app';
import { WorkflowsDropdownProps, WorkflowsDropdownRespSuccess } from './types';
import { useQueryParams } from '@hooks/queryParams';

export const useWorkflowsDropdown = ({ onlyActive, divisionId }: WorkflowsDropdownProps) => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const {
    params: { divisionIds },
    parseParams,
  } = useQueryParams();

  const queryParams = parseParams(
    { onlyActive, divisionIds: divisionId ? [divisionId] : divisionIds },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<WorkflowsDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.workflows, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/workflows${queryParams}` }),
    placeholderData: (previousData) => previousData as WorkflowsDropdownRespSuccess,
    enabled,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
